import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_AI_TWIN_DEMO_4 = {
  title:
    "Maya can request Nudges and Foresights\nfrom the AI Twin for marketers for all\nongoing campaigns, effectively utilizing\nit as a personalized assistant helping her\nto define/refine the marketing strategies\nin real time.",
  subtitle: "NUDGES & FORESIGHTS IN REAL-TIM",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("AITWIN_309"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("AITWIN_307"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "AI_TWIN/AI_Twin_04.png",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "AI_TWIN/InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "AI_TWIN/AI_TWIN_DEMO_4_computer.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
          effect: "animate-opacity",
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_4_bubble_1.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_4_bubble_2.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
          effect: "animate-opacity",
        },
      ]}
      pageNumber={"AITWIN_308"}
    />
  ),
};
